module.exports = __webpack_public_path__ + "img/horizontal_6_5_8023.7ecdb109.png";